import ResponsiveImage from 'components/core/ResponsiveImage'
import Markdown from 'markdown-to-jsx'
import { BlogPostModel } from 'models/core/BlogPostModel'
import React, { Fragment, FunctionComponent } from 'react'
import dayjs from 'dayjs'

type Props = {
  post: BlogPostModel['data']
}

const FullBlogPost: FunctionComponent<Props> = (props) => {
  return (
    <Fragment>
      <div className="blog-details lg:pt-60 pt-14 text-lg text-[#333] leading-[34px] font-normal blog-prose">
        <div className="container max-w-[990px]">
          <h2 className="text-[#333] text-3xl leading-[38px]">{props.post.attributes.title}</h2>
          <span className="text-[#333] text-[14px] mb-24 block">{dayjs(props.post.attributes.publishedAt).toString()}</span>
          <div className="mt-6">
            <Markdown>{props.post.attributes.content}</Markdown>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default FullBlogPost
